import request from 'utils/request'

/*---------  客户管理中心    -------*/
//获取列表
export const getPage = data => request().post('customer/page', data)
//信用主管
export const getListCManager = () => request().get('bp/apply/listCManager')
//保存-企业基本信息
export const addCuntomer = data => request().post('customer/add', data)
/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)

//业务类型
export const getBusinessList = () => request().get('business/jsonList')
//加入黑名单
export const addBlackList = id => request().get(`customer/blacklist/add/${id}`)
// 移出黑名单
export const removedBlacklist = id =>
  request().get(`customer/blacklist/delete/${id}`)
//判断是否为管理员角色
export const checkIsAdmin = () => request().get('credit/roleExist')
//保存-企业额外信息
export const addCuntomerDetails = data =>
  request().post('customer/addDetails', data)
//权限
export const getCustomerOverview = id =>
  request().get(`customer/overview/${id}`)

// 获取国家
export const getCountry = data =>
  request().get('sovereign/rate/getCountry', data)

// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')

// 获取业务类型冻结列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

// 获取评分卡LIST[] ,不包含“冻结”状态的
export const getRating = () => request().post('card/selectRating/list')
